// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 101 101"
    {...props}
  >
    <path
      fill="#fff"
      d="M50.4317 0C56.0199 25.179 75.6843 44.8434 100.863 50.4317C75.6843 56.0199 56.0199 75.6843 50.4317 100.863C44.8434 75.6843 25.179 56.0199 0 50.4317C25.179 44.8434 44.8434 25.179 50.4317 0Z"
    />
  </svg>
);
const IconBrandStar = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconBrandStar;
